<template>
  <div>
    <file-pond
      allow-multiple="true"
      :maxFiles="maxTotalFiles"
      :maxFileSize="maxFileSizeLabel"
      credits="false"
      name="file"
      ref="input"
      itemInsertLocation="after"
      @removefile="onremovefile"
      :beforeRemoveFile="beforeRemove"
      :beforeAddFile="beforeAddFile"
      allowFileTypeValidation="true"
      :acceptedFileTypes="acceptedFileTypes"
      filePosterMaxHeight="100"
      imagePreviewHeight="100"
      :server="{ process, restore, load, fetch: null }"
      :files="files"
      @init="handleFilePondInit"
    />
    <p class="upload-hint">{{ uploadHintText }}</p>
  </div>
</template>
<script>
/* eslint-disable no-unused-vars */

import API from '../../api';
import axios from 'axios';
import {
  getAcceptedFileTypes,
  getUploadHintText,
  getMaxTotalFiles,
  getMaxFileSizeLabel,
  MAX_FILES_PER_UPLOAD
} from '@/util/uploadFileTypes';

// Import Vue FilePond
import vueFilePond from 'vue-filepond';

// Import FilePond styles
import 'filepond/dist/filepond.min.css';

// Import image preview plugin styles
import 'filepond-plugin-image-preview/dist/filepond-plugin-image-preview.min.css';

// Import image preview and file type validation plugins
import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type';
import FilePondPluginImagePreview from 'filepond-plugin-image-preview';
// Import the plugin code
import FilePondPluginFilePoster from 'filepond-plugin-file-poster';

// Import the plugin styles
import 'filepond-plugin-file-poster/dist/filepond-plugin-file-poster.css';

// Register the plugin
// Create component
const FilePond = vueFilePond(FilePondPluginFileValidateType, FilePondPluginImagePreview, FilePondPluginFilePoster);

/* eslint-disable no-debugger */

let imageFiles = {};

/* eslint-disable-next-line  */
export default {
  name: 'Library',
  props: {},

  components: {
    FilePond
  },

  data: () => ({
    files: [],
    images: []
  }),
  //LOAD
  created: async function () {
    this.error = null;
    let res = await API.get('profile');
    if (!res) {
      return;
    }
    if (res.errors && res.errors.length > 0) {
      this.error = res.errors[0].msg;
    } else {
      this.error = null;

      this.images = res.data.files;
    }
  },
  mounted() {
    document.title = 'Edit Library';
  },
  computed: {
    acceptedFileTypes() {
      return getAcceptedFileTypes('proof');
    },
    uploadHintText() {
      return getUploadHintText('proof');
    },
    maxTotalFiles() {
      return getMaxTotalFiles('proof');
    },
    maxFileSizeLabel() {
      return getMaxFileSizeLabel('proof');
    }
  },
  methods: {
    process(fieldName, file, metadata, load, error, progress, abort) {
      const CancelToken = axios.CancelToken;
      const source = CancelToken.source();
      let cancelled = false;

      (async () => {
        try {
          // Step 1: ask the backend for a presigned S3 URL + uuid/key for this file
          let presignedRes = await API.post('file/presigned-url', {
            fileType: 'proof',
            fileName: file.name,
            contentType: file.type || 'application/octet-stream',
            needsThumbnail: false
          });

          if (presignedRes.errors && presignedRes.errors.length > 0) {
            error(presignedRes.errors[0].msg);
            return;
          }

          let { uuid, key, presignedUrl } = presignedRes.data;

          if (cancelled) return;

          // Step 2: upload the file directly to S3 using the presigned URL,
          // reporting progress back to FilePond and honoring cancellation.
          const s3Axios = axios.create();
          delete s3Axios.defaults.headers.common['Authorization'];

          await s3Axios.put(presignedUrl, file, {
            headers: {
              'Content-Type': file.type || 'application/octet-stream'
            },
            cancelToken: source.token,
            onUploadProgress: e => {
              progress(e.lengthComputable, e.loaded, e.total);
            }
          });

          if (cancelled) return;

          // Step 3: confirm the upload with the backend so a UserFile row gets created
          let confirmRes = await API.post('file/confirm-upload', {
            uuid,
            key,
            fileName: file.name,
            fileType: 'proof'
          });

          if (confirmRes.errors && confirmRes.errors.length > 0) {
            error(confirmRes.errors[0].msg);
            return;
          }

          // passing the file id to FilePond
          load(confirmRes.data.uuid);
        } catch (thrown) {
          if (axios.isCancel(thrown)) {
            console.log('Request canceled', thrown.message);
          } else {
            error(thrown.message || 'Upload failed');
          }
        }
      })();

      // Setup abort interface
      return {
        abort: () => {
          cancelled = true;
          source.cancel('Operation canceled by the user.');
          abort();
        }
      };
    },
    async onremovefile(err, file) {
      console.log('[DEBUG] onremovefile fired. err:', err, 'file:', file);
      console.log('[DEBUG] file.serverId:', file && file.serverId);
      if (err) {
        console.log('[DEBUG] BAILING: err was truthy');
        return;
      }
      if (!file || !file.serverId) {
        console.log('[DEBUG] BAILING: no file or no serverId');
        return;
      }

      let uuid = file.serverId;
      console.log('[DEBUG] Calling file/delete with uuid:', uuid);

      try {
        let res = await API.post('file/delete', { uuid });
        console.log('[DEBUG] file/delete response:', res);
      } catch (deleteErr) {
        console.log('[DEBUG] file/delete threw:', deleteErr);
      }

      this.images = this.images.filter(image => image.uuid !== uuid);
    },
    beforeRemove: file => true,
    beforeAddFile(fileItem) {
      return new Promise(resolve => {
        this._batchAddCount = (this._batchAddCount || 0) + 1;
        const thisCallCount = this._batchAddCount;

        Promise.resolve().then(() => {
          if (this._batchAddCount === thisCallCount) {
            this._batchAddCount = 0;
          }
        });

        if (thisCallCount > MAX_FILES_PER_UPLOAD) {
          this.error = `You can only add up to ${MAX_FILES_PER_UPLOAD} files at a time.`;
          resolve(false);
        } else {
          resolve(true);
        }
      });
    },
    load: (uniqueFileId, load, error, progress, abort, headers) => {
      let file = imageFiles[uniqueFileId];
      fetch(file.url)
        .then(res => {
          console.log(res);
          return res.blob();
        })
        .then(load);
    },
    fetch(url, load, error, progress, abort, headers) {
      error('not supported');
    },
    restore: (uniqueFileId, load, error, progress, abort, headers) => {
      // Previously this always called error() unconditionally, which meant
      // ANY file FilePond attempted to restore (e.g. if a controlled :files
      // update looked like a "new" local file rather than one already
      // tracked from an in-session upload) was guaranteed to disappear.
      // Mirror load()'s behavior instead so restore attempts can actually
      // succeed.
      let file = imageFiles[uniqueFileId];
      if (!file || !file.url) {
        error('File not found');
        return;
      }
      fetch(file.url)
        .then(res => res.blob())
        .then(load)
        .catch(() => error('Failed to load file'));
    },
    handleError(error, e) {
      switch (e.code) {
        case 'storage/canceled':
          break;
        default:
          error(e.message);
      }
    },
    handleFilePondInit: function () {
      //this.$refs.input.getFiles();
    }
  },
  watch: {
    images: {
      immediate: true,
      handler: function (images, oldVal) {
        let files = [];

        for (let index = 0; index < images.length; index++) {
          const image = images[index];
          imageFiles[image.uuid] = image;
          let file = {
            source: image.uuid,
            options: {
              type: 'local'
            }
          };
          files.push(file);
        }
        this.files = files;
      }
    }
  }
};
</script>

<style>
.avatar {
  width: 140px !important;
  height: 140px !important;
  top: -70px !important;
  left: 30px !important;
  border: 5px solid #fff;
}
.filepond--item {
  width: calc(50% - 0.5em);
}
.upload-hint {
  font-size: 12px;
  color: #888;
  margin-top: 6px;
  margin-bottom: 0;
}
</style>
